import {Component, OnInit} from '@angular/core';
import {UserResponse} from "../interface/userResponse";
import {UserService} from "../service/user.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {filter} from "rxjs";
import {NavigationEnd, Router} from "@angular/router";

@Component({
  selector: 'app-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrl: './admin-page.component.scss'
})
export class AdminPageComponent implements OnInit {
  user: UserResponse | any
  isUserPage = false;
  isReviewsPage = false;

  constructor(private userService: UserService,
              private snackBar: MatSnackBar,
              private router: Router) {
  }

  ngOnInit(): void {
    const email = this.userService.adminEmail;
    this.userService.findByEmail(email).subscribe({
      next: (response: UserResponse) => {
        this.user = response;
      },
      error: (error) => {
        this.handleErrorResponse(error);
      }
    });
    this.isUserPage = this.router.url.includes('/users');
    this.isReviewsPage = this.router.url.includes('reviews');
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.isUserPage = this.router.url.includes('/users');
      this.isReviewsPage = this.router.url.includes('reviews');
    });
  }

  private handleErrorResponse(error: any) {
    if (error.status === 404) {
      this.showSnackBar('User not found.', 'error');
    } else if (error.status === 500) {
      this.showSnackBar('Internal server error.', 'error');
    } else {
      this.showSnackBar('An unexpected error occurred.', 'error');
    }
  }

  private showSnackBar(message: string, panelClass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: [panelClass]
    });
  }
}
